import PropTypes from 'prop-types';
import { FEED_ENTRY_TYPES } from '../constants';

export const cursorDataProps = PropTypes.shape({
  updated_at: PropTypes.number.isRequired,
  rank: PropTypes.number // can be null when viewing feed type with a filter on athlete id
});

export const timeAndLocationProps = PropTypes.shape({
  displayDate: PropTypes.string,
  displayDateAtTime: PropTypes.string,
  location: PropTypes.string,
  timestampFormat: PropTypes.string
});

export const entityOwnerProps = PropTypes.shape({
  displayImage: PropTypes.string,
  memberType: PropTypes.string,
  name: PropTypes.string.isRequired,
  profileUrl: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  id: PropTypes.string
});

export const entityAthleteProps = PropTypes.shape({
  avatarUrl: PropTypes.string,
  athleteId: PropTypes.string.isRequired,
  memberType: PropTypes.string,
  athleteName: PropTypes.string.isRequired,
  sex: PropTypes.string,
  firstName: PropTypes.string.isRequired
});

export const indexProps = PropTypes.number;

export const cumulativeGoalAchievementProps = PropTypes.shape({
  type: PropTypes.string,
  amount: PropTypes.string
});

export const powerAndSegmentGoalAchievementsProps = PropTypes.arrayOf(
  PropTypes.shape({
    url: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
  })
);

export const segAndBestEffortAchievementsProps = PropTypes.arrayOf(
  PropTypes.shape({
    id_string: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    elapsed_time: PropTypes.string,
    featured: PropTypes.bool,
    hidden: PropTypes.bool,
    distance_based_best_effort: PropTypes.bool
  })
);

export const statsProps = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    url: PropTypes.string,
    description: PropTypes.string
  })
);

export const mapProps = PropTypes.shape({
  url: PropTypes.string,
  alt: PropTypes.string
});

export const photoProps = PropTypes.shape({
  large: PropTypes.string.isRequired,
  caption_escaped: PropTypes.string,
  photo_id: PropTypes.string.isRequired,
  viewing_athlete_id: PropTypes.string,
  owner_id: PropTypes.string,
  editable: PropTypes.bool
});

export const viewingAthleteProps = PropTypes.shape({
  avatarUrl: PropTypes.string,
  id: PropTypes.string.isRequired,
  memberType: PropTypes.string,
  name: PropTypes.string.isRequired,
  location: PropTypes.string,
  dateOfBirth: PropTypes.string
});

export const pageProps = PropTypes.oneOf([
  'dashboard',
  'club',
  'profile',
  'athlete'
]);

export const feedTypeProps = PropTypes.oneOf([
  'my_activity',
  'club',
  'following',
  'profile',
  'club',
  'athlete_posts'
]);

export const analyticsContextProps = PropTypes.shape({
  track: PropTypes.func.isRequired,
  props: PropTypes.shape({
    category: PropTypes.oneOf(['feed']).isRequired,
    page: pageProps.isRequired
  }).isRequired
});

export const photoListProps = PropTypes.arrayOf(photoProps);

export const commentsProps = PropTypes.arrayOf(
  PropTypes.shape({
    comment_id: PropTypes.number.isRequired,
    deletable: PropTypes.bool.isRequired,
    reportable: PropTypes.bool.isRequired,
    quarantinable: PropTypes.bool.isRequired,
    athlete: PropTypes.shape({
      name: PropTypes.string.isRequired,
      avatar_url: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      member_type: PropTypes.string
    })
  })
);

export const highlightedKudosersProps = PropTypes.arrayOf(
  PropTypes.shape({
    avatar_url: PropTypes.string.isRequired,
    destination_url: PropTypes.string.isRequired,
    display_name: PropTypes.string.isRequired,
    show_name: PropTypes.bool.isRequired
  })
);

export const kudosAndCommentsProps = PropTypes.shape({
  canKudo: PropTypes.bool.isRequired,
  kudosCount: PropTypes.number.isRequired,
  highlightedKudosers: highlightedKudosersProps.isRequired,
  comments: commentsProps.isRequired,
  commentsEnabled: PropTypes.bool, // only applies to `Post` entities
  reactionsEnabled: PropTypes.bool,
  undoCommentReactionsEnabled: PropTypes.bool
});

export const entitiesWithKudosAndComments = PropTypes.oneOf([
  FEED_ENTRY_TYPES.activity,
  FEED_ENTRY_TYPES.groupActivity,
  FEED_ENTRY_TYPES.post
]);
